import { render, staticRenderFns } from "./DeleteConfirmVideo.vue?vue&type=template&id=86033d64"
import script from "./DeleteConfirmVideo.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports